import React from "react";
import InformTable from "../Components/InformTable";

// Legacy format: { "Old": { ... }, "New": { ... } }
const ProductLegacy: React.FC<{ action: any }> = ({ action }) => {
    const oldEntries = Object.entries(action?.Old ?? {});
    const newEntries = Object.entries(action?.New ?? {});

    if (oldEntries.length === 0 && newEntries.length === 0) {
        return (
            <div className="inform_panel">
                <InformTable data={[]} label="No data available" />
            </div>
        );
    }

    const dataOld = oldEntries.map(([key, val]) => ({ property: key, value: String(val) }));
    const dataNew = newEntries.map(([key, val]) => ({ property: key, value: String(val) }));

    return (
        <div className="inform_panel">
            {dataOld.length > 0 && <InformTable data={dataOld} label="Old Version" />}
            {dataNew.length > 0 && <InformTable data={dataNew} label="New Version" />}
        </div>
    );
};

export default ProductLegacy;
